const UTCAbbreviation = 'UTC+0';
const UTCTimezone = 'UTC';

const UTCTimezoneObject = {
  id: UTCTimezone,
  baseUtcOffset: 0,
  currentOffset: 0,
  abbr: UTCAbbreviation,
};

const dateFormats = {
  twelveHoursFormat: 'hh:mm a',
  twentyFourHoursFormat: 'HH:mm',
  defaultDateFormat: 'MM/dd/yyyy',
  twelveHoursFormatShorten: 'ha',
};

export {UTCAbbreviation, UTCTimezone, UTCTimezoneObject, dateFormats};
